import axios from "axios";
import * as pushBridge from "@/services/pushBridge";
import {
    getOrCreatePushDeviceId,
    getLastSyncedToken,
    setLastSyncedToken,
    clearLastSyncedToken
} from "@/utils/pushDeviceStorage";
const errorsHandler = require("@/services/errors")

//Change This
const module = 'push_notifications';

let registerDevicePromise = null;

const state = {

}

const getters = {

}

const actions = {
    index : async (context,payload) => {

        let url = `api/v1/${module}`;
        if(context.rootGetters['user/getUser'].center_id){
            url += '?center_id=' + context.rootGetters['user/getUser'].center_id;
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    paginated : async (context,payload) => {

        let url = `api/v1/${module}/paginated`;
        if(context.rootGetters['user/getUser'].center_id){
            url += '?center_id=' + context.rootGetters['user/getUser'].center_id;
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    read : async (context,payload) => {

        let url = `api/v1/${module}/read/${payload.id}`;
        if(context.rootGetters['user/getUser'].center_id){
            url += '?center_id=' + context.rootGetters['user/getUser'].center_id;
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    // Registra il device sul backend per le push native.
    // No-op nel browser: senza bridge window.ucampPush non si registra nulla.
    // Il guard in-flight evita registrazioni concorrenti (mounted + eventi
    // ucamp-push-state innescati dallo stesso requestPermission).
    registerDevice: async (context) => {

        if (!pushBridge.isNativeApp()) {
            return { success: false, message: 'push_bridge_unavailable' }
        }

        if (registerDevicePromise) {
            return registerDevicePromise
        }

        registerDevicePromise = (async () => {
        try {

            const pushState = await pushBridge.requestPermission()

            if (!pushState || pushState.permission !== 'granted' || !pushState.token) {
                return { success: false, message: 'push_token_missing' }
            }

            if (pushState.token === getLastSyncedToken()) {
                return { success: true, message: 'push_already_synced' }
            }

            const payload = {
                device_id: getOrCreatePushDeviceId(),
                token: pushState.token,
                platform: pushState.platform,
                notifications_enabled: true,
                locale: navigator.language,
                user_agent: navigator.userAgent,
            }

            return await axios.post(`${context.rootGetters['settings/getEndpoint']}api/v1/admin-push-subscriptions/register/`, payload, {
                    'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                    "Content-Type": "application/json"
                },
            ).then(result => {

                setLastSyncedToken(pushState.token)
                return { success: true, result: result.data.result }

            }).catch(error => {
                return errorsHandler.errorHandler(error)
            });

        } catch (error) {
            return { success: false, message: error.message || 'push_register_failed' }
        }
        })()

        try {
            return await registerDevicePromise
        } finally {
            registerDevicePromise = null
        }

    },
    // Scollega il device dall'utente (chiamata al logout, PRIMA di perdere il Bearer).
    unregisterDevice: async (context) => {

        try {

            if (pushBridge.isNativeApp()) {

                const pushState = await pushBridge.getState()

                if (pushState && pushState.platform) {
                    await axios.post(`${context.rootGetters['settings/getEndpoint']}api/v1/admin-push-subscriptions/detach/`, {
                            device_id: getOrCreatePushDeviceId(),
                            platform: pushState.platform,
                        }, {
                            'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                            "Content-Type": "application/json"
                        },
                    )
                }

            }

        } catch (error) {
            // il detach non deve mai bloccare il logout
        } finally {
            clearLastSyncedToken()
        }

        return { success: true }

    },
    markAllAsRead: async (context) => {
        let url = `api/v1/${module}/read-all`;
        if(context.rootGetters['user/getUser'].center_id){
            url += '?center_id=' + context.rootGetters['user/getUser'].center_id;
        }
        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
            headers: {
                'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            return { success: true }
        }).catch(error => errorsHandler.errorHandler(error))
    }

}

const mutations = {

}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

